<template>
    <header>
        <nav>
            <router-link to="/">Home</router-link> |
            <router-link to="/overview">Lernstand</router-link> |
            <router-link to="/settings">Einstellungen</router-link> |
            <router-link to="/work">Üben</router-link> |
            <router-link to="/about">Info</router-link>
        </nav>
    </header>
</template>

<style scoped lang="scss">
    header{
        background: var(--c-blue) ;
        height:80px;
        display:flex;
        align-items: flex-end;
    }
    nav {
        padding: 35px;
        margin:auto;
        @media (max-width: 767px) {
             font-size:18px;
             padding: 10px;
        }
        a {
            font-weight: bold;
            color: var(--c-text);
            text-decoration:none;
            padding:5px 12px;
            &.router-link-exact-active {
            color: #5e83a8;
            }
        }
    }
</style>

<script>
export default {
  name: 'HeaderNav'
}
</script>
